/** Exact substitutions verified against router intent; never inferred from prose. */
export type LiteralReplacementSummary = { searchText: string; replacementText: string };

export function parseLiteralReplacementSummary(value: unknown): LiteralReplacementSummary[] | undefined {
  if (!Array.isArray(value) || value.length === 0) return undefined;
  if (!value.every((pair) => pair && typeof pair === "object"
    && typeof pair.searchText === "string" && pair.searchText.length > 0
    && typeof pair.replacementText === "string")) return undefined;
  return value.map(({ searchText, replacementText }) => ({ searchText, replacementText }));
}
